import { render } from "./ContainerReeferDetailsEditModal.vue?vue&type=template&id=20b2fb98&ts=true"
import script from "./ContainerReeferDetailsEditModal.vue?vue&type=script&lang=ts"
export * from "./ContainerReeferDetailsEditModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__